import { getCoreDataSecurityApplicationsByIdSlice } from './get';
import { patchCoreDataSecurityApplicationByIdSlice } from './patch';

export const { requestGetCoreDataSecurityApplicationsById, resetGetCoreDataSecurityApplicationsById } =
	getCoreDataSecurityApplicationsByIdSlice.asyncActionCreators;

export const { requestPatchCoreDataSecurityApplicationsById, resetPatchCoreDataSecurityApplicationsById } =
	patchCoreDataSecurityApplicationByIdSlice.asyncActionCreators;
